import { render, staticRenderFns } from "./classesManagement.vue?vue&type=template&id=65b6f890&"
import script from "./classesManagement.vue?vue&type=script&lang=js&"
export * from "./classesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports